<template>
	<div>
		<transition name="fade" mode="out-in">
			<component :is="currentComponent" :key="currentComponent"></component>
		</transition>
	</div>
</template>
<script>
export default {
	components: {
		process1: () => import("./process1.vue"),
		process2: () => import("./process2.vue"),
		process3: () => import("./process3.vue"),
		process4: () => import("./process4.vue"),
		process5: () => import("./process5.vue"),
		process6: () => import("./process6.vue"),
		process7: () => import("./process7.vue"),
		process8: () => import("./process8.vue"),
		process9: () => import("./process9.vue"),
		process10: () => import("./process10.vue"),
		process11: () => import("./process11.vue"),
		process12: () => import("./process12.vue"),
		process13: () => import("./process13.vue"),
		process14: () => import("./process14.vue"),
	},
	data() {
		return {
			currentComponent: "",
		};
	},
	created() {
		this.handleProcess();
	},
	mounted() {},
	methods: {
		// 获取单个索赔信息
		handleProcess() {
			const claimInfo = JSON.parse(sessionStorage.getItem("claimInfo"));
			// 保修期内机器零件故障
			if (claimInfo.repairType == 1) {
				// 故障件发货
				if (claimInfo.currentAudit.auditStatus == "5") {
					this.currentComponent = "process1";
				}
				// 代理商审核
				else if (claimInfo.currentAudit.auditStatus == "1") {
					this.currentComponent = "process2";
				}
				// 理光审核
				else if (claimInfo.currentAudit.auditStatus == "2" || claimInfo.currentAudit.auditStatus == "6") {
					this.currentComponent = "process3";
				}
				// 理光实物审批
				else if (claimInfo.currentAudit.auditStatus == "3" || claimInfo.currentAudit.auditStatus == "10") {
					this.currentComponent = "process4";
				}
				// 索赔发货
				else if (claimInfo.currentAudit.auditStatus == "4") {
					this.currentComponent = "process5";
				}
				// 理光资料后补审批
				else if (claimInfo.currentAudit.auditStatus == "8") {
					this.currentComponent = "process6";
				}
				// 特批申请
				else if (claimInfo.currentAudit.auditStatus == "13") {
					this.currentComponent = "process14";
				}
			}
			// 理光单独订购零件
			if (claimInfo.repairType == 2) {
				// 订单科审核
				if (claimInfo.currentAudit.auditStatus == "20") {
					this.currentComponent = "process7";
				}
				// 无需邮寄，直接实物审批
				else if (claimInfo.currentAudit.auditStatus == "21") {
					this.currentComponent = "process8";
				}
				// 申请方填地址
				else if ([23, 24].includes(claimInfo.currentAudit.auditStatus)) {
					this.currentComponent = "process1";
				}
				// 实物审批
				else if (claimInfo.currentAudit.auditStatus == "25") {
					this.currentComponent = "process8";
				}
				// 服务部测试审核
				else if (claimInfo.currentAudit.auditStatus == "26") {
					this.currentComponent = "process9";
				}
				// 服务部测试审核
				else if (claimInfo.currentAudit.auditStatus == "27") {
					this.currentComponent = "process10";
				}
				// 测试件待寄回
				else if ([28, 29].includes(claimInfo.currentAudit.auditStatus)) {
					this.currentComponent = "process11";
				}
				// 索赔发货
				else if (claimInfo.currentAudit.auditStatus == "30") {
					this.currentComponent = "process5";
				}
			}
			// 商品（耗材）故障
			if (claimInfo.repairType == 3) {
				// 服务部审核
				if (claimInfo.currentAudit.auditStatus == "41") {
					this.currentComponent = "process12";
				}
				// 无需邮寄
				else if (claimInfo.currentAudit.auditStatus == "42") {
					this.currentComponent = "process13";
				}
				// 申请方填地址
				else if (claimInfo.currentAudit.auditStatus == "43") {
					this.currentComponent = "process1";
				}
				// 实物审批
				else if (claimInfo.currentAudit.auditStatus == "44") {
					this.currentComponent = "process13";
				}
				// 索赔发货
				else if (claimInfo.currentAudit.auditStatus == "4") {
					this.currentComponent = "process5";
				}
			}
		},
	},
};
</script>
<style lang="scss" scoped>
/* 淡入淡出效果 */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

/* 滑动效果（可选） */
.slide-enter-active {
	transition: all 0.3s ease-out;
}
.slide-leave-active {
	transition: all 0.3s ease-in;
}
.slide-enter-from {
	opacity: 0;
	transform: translateX(30px);
}
.slide-leave-to {
	opacity: 0;
	transform: translateX(-30px);
}
</style>
